import { Card } from "@/components/ui/card";

interface Activity {
  id: string;
  type: string;
  amount: number;
  date: string;
  user?: {
    full_name: string | null;
  };
}

interface RecentActivitiesProps {
  activities: Activity[];
}

export const RecentActivities = ({ activities }: RecentActivitiesProps) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getTransactionTypeLabel = (type: string) => {
    switch (type) {
      case 'sale':
        return 'Vente';
      case 'restock':
        return 'Réapprovisionnement';
      case 'loss':
        return 'Perte';
      default:
        return type;
    }
  };

  return (
    <Card className="col-span-1 md:col-span-2 lg:col-span-3">
      <div className="p-6">
        <h3 className="text-xl font-semibold mb-4">
          Activités récentes
        </h3>
        <div className="space-y-4">
          {activities?.map((activity) => (
            <div
              key={activity.id}
              className="flex items-center justify-between border-b pb-2"
            >
              <div>
                <p className="font-medium">
                  {getTransactionTypeLabel(activity.type)}
                </p>
                <p className="text-sm text-gray-500">
                  {activity.user?.full_name || "Utilisateur inconnu"}
                </p>
              </div>
              <div className="text-right">
                <p className="font-medium">
                  {activity.amount.toLocaleString()} FCFA
                </p>
                <p className="text-sm text-gray-500">
                  {formatDate(activity.date)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};